// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"730d7f33","977":"0cb163e2"}[chunkId] + ".chunk.js";
};